import { LeanTypes } from '@wix/lean-components-infra';
import { object, boolean } from 'yup';
const leanBoolean = { leanSchema: { type: LeanTypes.boolean } };
const defaultProperties = object({
    isHidden: boolean()
        .meta(Object.assign({ description: 'sets visibility:hidden to the component style node' }, leanBoolean))
        .notRequired(),
    isCollapsed: boolean()
        .meta(Object.assign({ description: 'sets isCollapsed for component' }, leanBoolean))
        .notRequired(),
});
const disableableProperties = object({
    isDisabled: boolean()
        .meta(Object.assign({ description: 'disables the component' }, leanBoolean))
        .default(false),
});
export { defaultProperties, disableableProperties };
//# sourceMappingURL=Core.schema.js.map